import { call, put, throttle } from 'redux-saga/effects';
import * as fieldsConfigActions from '../actions/fieldsActions';
import { getProfiles } from '../../api/filters';

function* getRequestProfilesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProfiles, payload);
    yield put(fieldsConfigActions.getRequestProfilesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getRequestProfilesError(error));
  }
}

export function* fieldsConfigWatcher() {
  yield throttle(
    900,
    fieldsConfigActions.getRequestProfiles.toString(),
    getRequestProfilesSaga
  );
}
